
import React      from 'react';
import PropTypes  from 'prop-types';


const SmallTableHeader = ({
  name,
  fontSize,
  color
}) => (
  <div style={{textAlign: 'Center', 
              backgroundColor: color, 
              fontSize: fontSize, 
              fontWeight: 'bold',
              padding: 4}}>
    <span>
      { name }
    </span>
  </div>
);

SmallTableHeader.propTypes = {
  name:  PropTypes.string,
  fontSize:  PropTypes.string,
  color:       PropTypes.string
};

SmallTableHeader.defaultProps = {
  name:  ' ',
  fontSize:  '100%',
  color:  '#84dcf2'
};

export default SmallTableHeader;



// WEBPACK FOOTER //
// ./src/app/components/smallTableHeader/SmallTableHeader.js